module.exports = __webpack_public_path__ + "static/media/closeAccentIcon.8d2506a5.svg";